import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { Pipe, PipeTransform } from "@angular/core";
import { ConfigurationService } from "../services/configuration.service";
@Pipe({
  name: "shuttle",
  pure: false
})
export class ShuttlePipe implements PipeTransform {
  private readonly cabRegEx = /(Cab|Office\sCab)/gi;
  constructor(private configSvc: ConfigurationService) {}

  transform(value: string): Observable<string> {
    return this.configSvc.configurations.pipe(
      map(cfg => (cfg.flattenedSettings.isShuttleRequired ? value.replace(this.cabRegEx, "Shuttle") : value))
    );
  }
}
